import { FC, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import downArrow from "../../Assets/arrow-down.png";
import merch from "../../Assets/homev2/footer-merch.png";
import payments from "../../Assets/homev2/footer-payments.png";
import trusted from "../../Assets/homev2/footer-trusted-partner.png";
import logo from "../../Assets/homev2/logo.png";
import EmailInputV2 from "../Communication/EmailInputV2";
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  YoutubeIcon,
} from "../Icons";

const footerInfo: Array<{
  title: string;
  id: number;
  links?: React.ReactNode;
  getLinks?: (pathname: string, search: string) => React.ReactNode;
}> = [
	{
		title: "Solutions",
		id: 0,
		getLinks: (pathname, search) => {
			const returnTo = `returnTo=${encodeURIComponent(pathname + search)}`;
			return (
				<>
					<Link to={`/reach-out?services=sales-strategy&${returnTo}`} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Sales & Strategy</Link>
					<Link to={`/reach-out?services=business-development&${returnTo}`} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Business Development</Link>
					<Link to={`/reach-out?services=brand-creative&${returnTo}`} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Brand & Creative</Link>
					<Link to={`/reach-out?services=digital-marketing&${returnTo}`} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Digital Marketing</Link>
					<Link to={`/reach-out?services=copy-content&${returnTo}`} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Copy & Content</Link>
					<Link to={`/reach-out?services=video-production&${returnTo}`} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Video Production</Link>
					<Link to={`/reach-out?services=ai-tech&${returnTo}`} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Web & Tech</Link>
					<Link to="/talent-ondemand" className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Build My Team</Link>
					<Link to={`/reach-out?${returnTo}`} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Customize My Solution</Link>
				</>
			);
		},
	},
	{
		title: "Membership",
		id: 1,
		getLinks: (pathname, search) => {
			const returnTo = `returnTo=${encodeURIComponent(pathname + search)}`;
			return (
				<>
					<Link to={`/reach-out?${returnTo}`} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Enterprise</Link>
					<Link to={`/reach-out?${returnTo}`} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Growth</Link>
					<Link to={`/reach-out?${returnTo}`} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Launch</Link>
					<Link to={`/reach-out?${returnTo}`} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Experience</Link>
					<Link to={`/reach-out?${returnTo}`} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">#SalesExperience</Link>
				</>
			);
		},
	},
	{
		title: "Resources",
		id: 2,
		getLinks: (pathname, search) => (
			<>
				<a href="/lobby" className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Enter Virtual Lobby</a>
				<Link to={`/reach-out?returnTo=${encodeURIComponent(pathname + search)}`} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Value Content</Link>
				<Link to={`/reach-out?returnTo=${encodeURIComponent(pathname + search)}`} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Tools</Link>
				<a href="/about" className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">About Us</a>
				<Link to="/reach-out" state={{ from: pathname + search }} className="text-white min-w-max hover:text-[#84CC16] transition-all ease-in-out duration-300">Reach Out</Link>
			</>
		),
	},
];

const FooterV2: FC = () => {
  const { pathname, search } = useLocation();
  const [promosCliked, setpromosCliked] = useState(false);

  const handelPromos = () => {
    setpromosCliked(true);
    setTimeout(() => {
      setpromosCliked(false);
    }, 1500);
  };

  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const isActive = (index: number) => {
    return activeIndex === index;
  };

  return (
    <footer className="bg-[#222222] w-full">
      <div className="w-full max-w-[1500px] mx-auto px-4 py-4 lg:py-10">
        <div className="pt-4 lg:pt-10 pb-6  md:pb-10 flex flex-col md:flex-row md:flex-wrap md:gap-10 justify-between">
          {footerInfo.map((info) => {
            return (
              <div className="space-y-2 md:space-y-8" key={info.id}>
                <h3 className="text-xl hidden md:block text-white font-bold">
                  {info.title}
                </h3>

                <div className="flex items-center  justify-between border-b md:border-none md:hidden border-[#707070] py-3">
                  <h3 className="text-xl text-white font-bold">{info.title}</h3>
                  <img
                    src={downArrow}
                    alt="downArrow"
                    onClick={() =>
                      setActiveIndex(isActive(info.id) ? null : info.id)
                    }
                    className={`transition-all duration-500 ease-in-out ${isActive(info.id) && "transform rotate-180"
                      } md:hidden w-3 h-2 cursor-pointer `}
                  />
                </div>
                <div
                  className={`flex md:max-h-96 md:opacity-100 overflow-hidden flex-col gap-4  md:transition-none transition-all duration-500 ease-in-out transform ${isActive(info.id)
                    ? "max-h-96 opacity-100 translate-y-0"
                    : "max-h-0 opacity-0 -translate-y-4"
                    } `}
                >
                  {info.getLinks ? info.getLinks(pathname, search) : info.links}
                </div>
              </div>
            );
          })}

          <div className="space-y-8 hidden md:block mx-auto lg:mx-0">
            <h3 className="text-xl text-white font-bold">Got Merch?</h3>
            <img
              src={merch}
              alt="Merchandize"
              width="100%"
              height="100%"
              loading="lazy"
            />
          </div>
          <div className="my-10 md:space-y-8 md:mx-auto 2xl:mx-0 md:my-0 text-center md:text-start   ">
            <h3 className="text-xl mb-4 md:mb-0 text-white font-bold">
              Receive News & Updates
            </h3>
            <EmailInputV2 isCliked={promosCliked} />
            <div className="w-max hidden md:block md:ml-auto">
              <img src={trusted} alt="Trusted Brands" />
            </div>

          </div>
        </div>
        <div className="space-y-6 text-center md:hidden">
          <h3 className="text-xl text-white font-bold">Got Merch?</h3>
          <img
            src={merch}
            alt="Merchandize"
            width="100%"
            height="100%"
            loading="lazy"
          />
        </div>
        <div className=" flex md:hidden justify-center my-10 items-center gap-6 text-white">
          <a
            href="https://www.linkedin.com/company/sales-mrkt/"
            target="_blank"
            rel="noreferrer"
          >
            <LinkedInIcon />
          </a>
          <a
            href="https://www.youtube.com/@salesmrkt"
            target="_blank"
            rel="noreferrer"
          >
            <YoutubeIcon />
          </a>
          <a
            href="https://www.instagram.com/salesmrkt_/"
            target="_blank"
            rel="noreferrer"
          >
            <InstagramIcon />
          </a>
          <a
            href="https://www.facebook.com/Salesmrkt.B2B.Marketplace"
            target="_blank"
            rel="noreferrer"
          >
            <FacebookIcon />
          </a>
        </div>

        <div className="w-max  mx-auto md:hidden md:ml-auto">
          <img src={trusted} alt="Trusted  Partener" />
        </div>
        <hr className="w-full  border-b border-[#707070] my-7" />
        <div className="flex items-center  justify-center md:justify-between flex-wrap gap-10 py-10">
          <a href="/" className="block md:hidden mx-auto max-w-lg">
            <img
              src={logo}
              alt="Salesmrkt Logo "
              width="100%"
              height="100%"
              loading="lazy"
            />
          </a>
          <div className="flex items-center md:items-end text-white text-xs gap-4">
            <a href="/" className="md:block hidden">
              <img
                src={logo}
                alt="Salesmrkt Logo "
                width="100%"
                height="100%"
                loading="lazy"
              />
            </a>
            <h4>
              © {new Date().getFullYear()}, Salesmrkt. All Rights Reserved.
            </h4>
            <a href="/privacy-policy" className="ml-auto w-fit underline text-white hover:text-blue">
              Privacy Policy
            </a>
            •
            <a href="/terms" className="ml-auto w-fit underline text-white hover:text-blue">
              Terms & Conditions
            </a>
          </div>
          <div className=" hidden md:flex items-center gap-6 text-white">
            <a
              href="https://www.linkedin.com/company/sales-mrkt/"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedInIcon />
            </a>
            <a
              href="https://www.youtube.com/@salesmrkt"
              target="_blank"
              rel="noreferrer"
            >
              <YoutubeIcon />
            </a>
            <a
              href="https://www.instagram.com/salesmrkt_/"
              target="_blank"
              rel="noreferrer"
            >
              <InstagramIcon />
            </a>
            <a
              href="https://www.facebook.com/Salesmrkt.B2B.Marketplace"
              target="_blank"
              rel="noreferrer"
            >
              <FacebookIcon />
            </a>
          </div>
          <div>
            <img src={payments} alt="" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterV2;
